/* TEAM ISLAM — custom scripts
 *
 * ---------------------------------------------------------------------------
 * Relevant sizes only.
 * ---------------------------------------------------------------------------
 * With Fit = Men, the Size row rendered all 13 values — S…4XL plus Youth S/M/L/XL
 * and Kids 4T/5-6T/7T — with the nine impossible ones struck through. Nine of
 * thirteen chips crossed out reads as "sold out", which is what the owner saw.
 * Worse, `.is-disabled` is only a class: the radio underneath stays clickable,
 * so a customer could select Men × Youth XL, a combination that has no variant,
 * and land on a dead "Unavailable" button.
 *
 * WHY NOT JUST HIDE `.is-disabled`:
 * the theme's createAvailableOptionsTree() sets isUnavailable when a variant is
 * missing OR merely out of stock — those two cases collapse into one class.
 * Hiding it would also hide a size that genuinely exists and is sold out, which
 * removes information the shopper needs. So availability is recomputed here from
 * the variant JSON, keyed on existence only:
 *
 *   combination has no variant  -> hidden      (Men × Kids 4T)
 *   variant exists, out of stock -> left alone (theme keeps its strikethrough)
 *
 * Filtering cascades and never touches the first option: option1 is always shown
 * in full, option2 is filtered by option1, option3 by option1+option2. Filtering
 * the first option would strand the shopper — picking size S would hide "Kids".
 */
(function () {
  'use strict';

  function setup(root) {
    var json = root.querySelector('script[type="application/json"]');
    if (!json) return;

    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    var fieldsets = Array.prototype.slice.call(root.querySelectorAll('.product-form__input'));
    if (fieldsets.length < 2) return;               // single-option products need no filtering

    var busy = false;

    function optionKey(fs, i) {
      var n = parseInt(String(fs.dataset.index || '').replace('option', ''), 10);
      return 'option' + (isNaN(n) ? i + 1 : n);
    }

    function selectedValue(fs) {
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;
      var select = fs.querySelector('select');
      return select ? select.value : null;
    }

    function apply() {
      if (busy) return;
      var selected = fieldsets.map(selectedValue);

      fieldsets.forEach(function (fs, i) {
        if (i === 0) return;                        // never filter the first option

        var key = optionKey(fs, i);

        // values that exist for the current selections of every PRECEDING option
        var exists = Object.create(null);
        variants.forEach(function (v) {
          for (var j = 0; j < i; j++) {
            if (selected[j] != null && v[optionKey(fieldsets[j], j)] !== selected[j]) return;
          }
          if (v[key] != null) exists[v[key]] = true;
        });

        var firstValid = null;
        var currentStillValid = false;

        fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var ok = !!exists[input.value];
          input.classList.toggle('ti-option-missing', !ok);
          // the theme styles the chip as `input + label`, so the label is the visible part
          if (input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL') {
            input.nextElementSibling.classList.toggle('ti-option-missing', !ok);
          }
          if (ok && firstValid === null) firstValid = input;
          if (ok && input.checked) currentStillValid = true;
        });

        fs.querySelectorAll('select option').forEach(function (opt) {
          opt.hidden = !exists[opt.value];
        });

        // Switching Fit can strand the old Size (Men/S -> Kids has no S). Move to
        // the first size that exists rather than leaving a dead "Unavailable".
        if (!currentStillValid && firstValid) {
          busy = true;
          firstValid.checked = true;
          firstValid.dispatchEvent(new Event('change', { bubbles: true }));
          busy = false;
        }
      });
    }

    // Re-run after the theme's own change handler, which repaints .is-disabled.
    root.addEventListener('change', function () { setTimeout(apply, 0); });
    apply();
  }

  function init() {
    document.querySelectorAll('variant-selects').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* TI-082 — safety net for the "Personalise" accordion.
   product.js's onSubmitHandler does `if (!this.form.reportValidity()) return;`.
   A required control inside a CLOSED <details> is invalid and not focusable, so
   Add to Cart would silently do nothing. The Liquid deliberately keeps required
   options OUT of the accordion, but a merchant can tick "required" on one of
   the optional blocks in the theme editor at any time and re-create that trap.
   The `invalid` event fires on the control during reportValidity() and does not
   bubble, so capture it on the document: opening the <details> before the
   validity pass finishes makes the control focusable and the prompt appears
   where the customer can act on it. */
(function () {
  document.addEventListener(
    'invalid',
    function (e) {
      var d = e.target.closest && e.target.closest('.ti-personalise details');
      if (d && !d.open) d.open = true;
    },
    true
  );
})();



/* TI-151 — disclosure semantics for the desktop header dropdowns.
   The theme's own CSS already reveals a sub-menu on :hover and on
   :focus-within, and that reveal works. What was missing was the *announced*
   state and a way to dismiss: the launcher carried no aria-expanded, and
   Escape did nothing. This adds only those two things. It never fights the
   theme's reveal — aria-expanded mirrors the state the CSS is already in, and
   the collapsed class is applied only on an explicit Escape and released the
   moment focus or the pointer returns. Mobile drawer markup is untouched. */
(function () {
  var COLLAPSED = 'ti-collapsed';
  var counter = 0;

  function wire(li) {
    if (li.getAttribute('data-ti-disclosure')) return;
    var launcher = li.querySelector(':scope > a');
    var sub = li.querySelector(':scope > .sub-menu');
    if (!launcher || !sub) return;
    li.setAttribute('data-ti-disclosure', '1');

    if (!sub.id) sub.id = 'ti-submenu-' + ++counter;
    launcher.setAttribute('aria-controls', sub.id);
    launcher.setAttribute('aria-expanded', 'false');

    function expanded(is) {
      launcher.setAttribute('aria-expanded', is ? 'true' : 'false');
    }
    function release() {
      li.classList.remove(COLLAPSED);
    }

    li.addEventListener('focusin', function () { release(); expanded(true); });
    li.addEventListener('mouseenter', function () { release(); expanded(true); });
    li.addEventListener('mouseleave', function () {
      if (!li.contains(document.activeElement)) expanded(false);
    });
    li.addEventListener('focusout', function (e) {
      if (!li.contains(e.relatedTarget)) { release(); expanded(false); }
    });
    li.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      if (li.classList.contains(COLLAPSED)) return;
      li.classList.add(COLLAPSED);
      expanded(false);
      launcher.focus();
      e.stopPropagation();
    });
  }

  function init() {
    var items = document.querySelectorAll('.thb-full-menu li.menu-item-has-children');
    Array.prototype.forEach.call(items, wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Theme editor re-renders sections; re-wire without duplicating listeners. */
  document.addEventListener('shopify:section:load', init);
})();


/* ==========================================================================
   TI-155 — Story Subject resolver (Phase 2J, 2026-08-27)

   Maps the Hero picker's selected value to a Story Subject from the
   merchant-owned `team_islam_story_subject` library, and shows the short
   contextual line ONLY when that subject is cleared for storytelling.

   Resolution is EXACT-MATCH ONLY, in a fixed order:
     1. canonical_picker_value
     2. an explicitly registered legacy_picker_values entry
     3. null
   There is no case folding, no trimming, no transliteration guessing and no
   nearest-match fallback. These are sacred names; a near miss must fail rather
   than resolve to the wrong person. "MEMBERS ONLY" is not a subject and
   correctly resolves to null.

   Data comes from a JSON island rendered by snippets/ti-story-context.liquid.
   No network request, no Storefront API call. If the island is absent this
   whole module is inert.
   ========================================================================== */
(function () {
  'use strict';
  if (window.TIStory) { return; }

  var ISLAND = 'script[type="application/json"][data-ti-story-subjects]';
  var PICKER = 'select[name^="properties["]';

  var subjects = [];
  var byCanonical = Object.create(null);
  var byLegacy = Object.create(null);

  function buildIndex() {
    subjects = [];
    byCanonical = Object.create(null);
    byLegacy = Object.create(null);

    var island = document.querySelector(ISLAND);
    if (!island) { return; }
    try {
      subjects = JSON.parse(island.textContent) || [];
    } catch (err) {
      subjects = [];
      return;
    }

    var i, j, s, v;
    for (i = 0; i < subjects.length; i++) {
      s = subjects[i];
      if (!s || typeof s.c !== 'string' || typeof s.k !== 'string') { continue; }
      /* A duplicate canonical value would make resolution ambiguous. Keep the
         first and drop the rest rather than silently overwriting. */
      if (!(s.c in byCanonical)) { byCanonical[s.c] = s; }
    }
    for (i = 0; i < subjects.length; i++) {
      s = subjects[i];
      if (!s || !s.l || !s.l.length) { continue; }
      for (j = 0; j < s.l.length; j++) {
        v = s.l[j];
        if (typeof v !== 'string' || v === '') { continue; }
        /* A canonical value always outranks a legacy alias, and a legacy value
           claimed by two subjects is ambiguous — drop it rather than guess. */
        if (v in byCanonical) { continue; }
        if (v in byLegacy && byLegacy[v] !== s) { byLegacy[v] = null; continue; }
        byLegacy[v] = s;
      }
    }
  }

  /* Returns the matching subject, or null. Never throws, never guesses. */
  function resolve(value) {
    if (typeof value !== 'string' || value === '') { return null; }
    if (value in byCanonical) { return byCanonical[value]; }
    if (value in byLegacy && byLegacy[value]) { return byLegacy[value]; }
    return null;
  }

  /* The display gate. All conditions, every time.
     The fourth condition is the collision rule: if this product already tells
     its own approved story about this exact subject, the reusable story stays
     out of the way. Exact key comparison — never a title match. */
  function ownStoryKey() {
    var el = document.querySelector('[data-ti-story-subjects]');
    return (el && el.getAttribute('data-ti-product-story-key')) || '';
  }
  function canShow(subject) {
    if (!(subject && subject.a === 1 && typeof subject.m === 'string' && subject.m !== '')) {
      return false;
    }
    if (subject.k && subject.k === ownStoryKey()) { return false; }
    return true;
  }

  /* TI-163 — the long story is progressive disclosure: a real button, collapsed
     by default, that reveals a sibling panel. It is reset to collapsed on every
     subject change so a story can never outlive the hero it belongs to. */
  function renderStory(box, subject) {
    var toggle = box.querySelector('[data-ti-story-toggle]');
    var panel = box.querySelector('[data-ti-story-panel]');
    if (!toggle || !panel) { return; }

    var story = (subject && typeof subject.s === 'string') ? subject.s : '';
    /* Always collapse first: switching hero must never leave the previous
       story open, or expanded underneath a different name. */
    toggle.setAttribute('aria-expanded', 'false');
    panel.hidden = true;

    if (!story) {
      panel.textContent = '';
      toggle.hidden = true;
      return;
    }
    /* Paragraphs, built as text nodes — never innerHTML. The copy is merchant
       content, but it still has no business being parsed as markup. */
    panel.textContent = '';
    var parts = story.split(/\n\s*\n/), i, p;
    for (i = 0; i < parts.length; i++) {
      if (!parts[i].trim()) { continue; }
      p = document.createElement('p');
      p.textContent = parts[i].trim();
      panel.appendChild(p);
    }
    toggle.hidden = false;
  }

  function render(subject) {
    var box = document.querySelector('[data-ti-story-context]');
    if (!box) { return; }
    var line = box.querySelector('[data-ti-story-context-line]');
    if (!line) { return; }
    renderStory(box, canShow(subject) ? subject : null);
    if (canShow(subject)) {
      /* Unhide BEFORE writing the text. An aria-live region inside a
         display:none subtree is not monitored, so setting the text first meant
         the polite announcement could never fire for a screen-reader user
         changing the Hero. No rAF here on purpose — requestAnimationFrame is
         throttled in a backgrounded tab, which would leave the line blank. */
      box.hidden = false;
      line.textContent = subject.m;
    } else {
      /* Clearing first matters: stale copy must never outlive the selection
         that produced it, including when the new selection resolves to a
         subject that simply is not cleared for storytelling. */
      line.textContent = '';
      box.hidden = true;
    }
  }

  /* TI-158 — one neutral selection event (Phase 2L). Replaces the Phase 2K
     `hero_story_context_view`, which is deprecated and no longer sent.

     WHAT IS MEASURED: that a valid Hero was selected, and whether the customer
     actually saw story context. Nothing else.

     WHAT IS DELIBERATELY NOT SENT: the subject key, canonical picker value,
     display name, subject type, category, story copy, the custom name, the
     custom number, or any customer/cart identifier. The resolver still uses
     those locally to render the page — they simply never leave the storefront.
     One event gives a single clean denominator (all valid Hero selections) with
     a boolean numerator, rather than two partially overlapping events. */
  var lastTracked = null;

  /* CONSENT. A raw gtag() call from theme code is a plain queue push and is NOT
     routed through Shopify's Customer Privacy API the way Shopify's own pixels
     and app pixels are, and this shop sets no Consent Mode defaults. So the
     Phase 2K event would have fired for a visitor in a regulated region who had
     not consented, while the platform's own analytics correctly stayed silent.
     This gate closes that gap. It fails CLOSED: if the privacy API is missing or
     throws, nothing is sent. */
  function analyticsAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return cp.analyticsProcessingAllowed() === true;
      }
    } catch (err) { /* fall through to deny */ }
    return false;
  }

  function productId() {
    try { return window.ShopifyAnalytics.meta.product.id || null; } catch (err) { return null; }
  }

  function trackSelection(subject) {
    /* An unmapped value, MEMBERS ONLY or the placeholder is not a selection.
       Clearing lastTracked here keeps A -> placeholder -> A as two real
       actions, which is what the customer did. */
    if (!subject) { lastTracked = null; return; }
    /* Dedupe only against the immediately preceding selection, so a handler
       that runs twice for one state sends once, while a deliberate
       A -> B -> A still counts as three interactions. Never dedupe a subject
       for the whole session: these are interaction events, not unique counts.
       The canonical value is used as a local comparison key only. */
    if (lastTracked === subject.c) { return; }
    lastTracked = subject.c;
    if (!analyticsAllowed()) { return; }

    var payload = {
      product_id: productId(),
      story_context_shown: canShow(subject)
    };

    /* ONE path only: Shopify's own customer-event bus, which the
       "Team Islam — Hero Pilot GA4" custom pixel subscribes to and forwards.

       The raw main-document gtag() call was REMOVED on 2026-08-28. It was
       harmless while the store's Google tag had no GA4 destination — it
       transmitted nothing — but the moment a property is connected that path
       would start working too, and every selection would be counted TWICE:
       once from the theme and once from the pixel. Removing it also restores
       the intended architecture: picker -> resolver -> publish -> pixel -> GA4,
       with no parallel path. See BACKLOG.md, Phase 2M. */
    try {
      if (window.Shopify && window.Shopify.analytics &&
          typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('hero_selection', payload);
      }
    } catch (err) { /* analytics must never break the picker */ }
  }

  function apply(select, userAction) {
    var subject = resolve(select.value);
    if (subject) {
      select.setAttribute('data-ti-story-subject-key', subject.k);
    } else {
      select.removeAttribute('data-ti-story-subject-key');
    }
    render(subject);
    /* Only a real change event measures. Page initialisation, Liquid
       rendering, resolver indexing, section setup and browser-restored form
       state all render the line but emit nothing — a restored value is not a
       fresh customer decision, so counting it would inflate the denominator
       with non-interactions. */
    if (userAction) { trackSelection(subject); }
    return subject;
  }

  /* A product page can carry several line-item dropdowns (colour, and so on).
     Only the one whose OPTIONS belong to the Story Subject library is a hero
     picker — so changing colour can never blank a hero's line. */
  function isHeroPicker(select) {
    var opts = select.options, i;
    for (i = 0; i < opts.length; i++) {
      if (resolve(opts[i].value)) { return true; }
    }
    return false;
  }

  function init() {
    buildIndex();
    if (!subjects.length) { return; }
    var selects = document.querySelectorAll(PICKER), i, sel;
    for (i = 0; i < selects.length; i++) {
      sel = selects[i];
      if (!isHeroPicker(sel)) { continue; }
      sel.setAttribute('data-ti-story-picker', '');
      /* Resolve whatever is selected right now — covers the placeholder, a
         browser-restored value after a back-navigation, and a preselection. */
      apply(sel);
    }
  }

  /* TI-164 — story engagement. Fires ONLY on a real collapsed -> open click.
     Never on selection, render, page load, section init, or a close. A genuine
     open -> close -> reopen counts twice, because that is two interactions;
     it is deliberately NOT deduped for the session.

     Carries product_id and nothing else. Which historical or religious subject
     the shopper chose is none of the analytics system's business, so the
     subject key is not sent here any more than it is on hero_selection. */
  function trackStoryOpened() {
    if (!analyticsAllowed()) { return; }
    try {
      if (window.Shopify && window.Shopify.analytics &&
          typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('hero_story_opened', {
          product_id: productId()
        });
      }
    } catch (err) { /* analytics must never break the disclosure */ }
  }

  /* Disclosure toggle — one delegated listener, same pattern as the picker. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var toggle = t.closest('[data-ti-story-toggle]');
    if (!toggle) { return; }
    var box = toggle.closest('[data-ti-story-context]');
    var panel = box && box.querySelector('[data-ti-story-panel]');
    if (!panel) { return; }
    var open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    panel.hidden = open;
    /* `open` is the state BEFORE the click, so !open means this click opened
       it. One click, one event — a duplicated handler cannot double-fire
       because the attribute has already flipped. */
    if (!open) { trackStoryOpened(); }
  });

  /* One delegated listener for the life of the page. No polling, no timers,
     no per-element handlers to duplicate on a section re-render. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.tagName !== 'SELECT') { return; }
    if (!t.hasAttribute('data-ti-story-picker')) { return; }
    apply(t, true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Theme editor re-renders the product section; re-index and re-mark. */
  document.addEventListener('shopify:section:load', init);

  window.TIStory = {
    resolve: resolve,
    canShow: canShow,
    refresh: init,
    get subjects() { return subjects.slice(); }
  };
})();


/* ==========================================================================
   TI-161 — Hero personalisation is EITHER/OR (2026-08-28)

   The PDP offered "Choose Your Hero" and "Your Custom Hero Name*" at once, so a
   cart line could carry both — two conflicting instructions for one garment.
   A mode selector now exposes exactly one path at a time.

   The control that is not in use is DISABLED, not merely hidden. A hidden but
   enabled field still posts to /cart/add, which is precisely the bug being
   fixed. Its value is also cleared, so nothing stale can survive a mode switch.

   Order of operations when hiding matters: required is removed BEFORE the field
   is hidden. A hidden field still carrying `required` makes Chrome refuse to
   submit with "An invalid form control is not focusable" — an unfixable-looking
   dead Add to Cart button.
   ========================================================================== */
(function () {
  'use strict';
  if (window.TIHeroMode) { return; }

  var CONFIG = 'script[type="application/json"][data-ti-hero-mode-config]';
  var OPTION = '[data-ti-hero-mode-option]';

  function config() {
    var el = document.querySelector(CONFIG);
    if (!el) { return null; }
    try {
      var c = JSON.parse(el.textContent);
      return (c && c.preset && c.custom) ? c : null;
    } catch (err) { return null; }
  }

  /* Match on the exact name attribute rather than a CSS attribute selector:
     these names contain [ ] * and spaces, which would otherwise need escaping. */
  function control(name) {
    var all = document.querySelectorAll('[name^="properties["]'), i;
    for (i = 0; i < all.length; i++) {
      if (all[i].getAttribute('name') === name) { return all[i]; }
    }
    return null;
  }

  /* Hide the whole field, not just the input, so its label goes with it. */
  function field(el) {
    return el.closest('fieldset.product-information--line-item') ||
           el.closest('fieldset') || el.parentElement;
  }

  function apply(mode) {
    var cfg = config();
    if (!cfg) { return; }
    var preset = control(cfg.preset);
    var custom = control(cfg.custom);
    if (!preset || !custom) { return; }

    if (mode === 'custom') {
      /* Clearing the picker also clears any Story Subject line through the
         existing change listener, and leaves the resolver unmapped so no
         hero_selection is emitted for a custom name. A custom name is never
         resolved, never fuzzy-matched, and never becomes a Story Subject. */
      if (preset.value !== '') {
        preset.value = '';
        preset.dispatchEvent(new Event('change', { bubbles: true }));
      }
      preset.disabled = true;
      field(preset).hidden = true;

      field(custom).hidden = false;
      custom.disabled = false;
      custom.required = true;
    } else {
      if (custom.value !== '') {
        custom.value = '';
        custom.dispatchEvent(new Event('input', { bubbles: true }));
      }
      custom.required = false;   /* BEFORE hiding — see header note */
      custom.disabled = true;
      field(custom).hidden = true;

      field(preset).hidden = false;
      preset.disabled = false;
    }
  }

  function init() {
    var checked = document.querySelector(OPTION + ':checked');
    if (!checked && !document.querySelector(OPTION)) { return; }
    apply(checked ? checked.value : 'preset');
  }

  /* One delegated listener for the life of the page. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.hasAttribute || !t.hasAttribute('data-ti-hero-mode-option')) { return; }
    apply(t.value);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);

  window.TIHeroMode = { apply: apply, refresh: init };
})();
